export default {
  title: '商品情報',
  isDisposals: '処分品',
  productStocknumTag: '在庫わずか',
  brandName: 'ブランド',
  countryOfOrigin: '原産地',
  productNo: '品番',
  productPointNum: '付与ﾎﾟｲﾝﾄ',
  couponTags: 'ｸｰﾎﾟﾝ',
  activityTitles: 'ｷｬﾝﾍﾟﾝ',
  specValueName: '規格選択',
  dispatchInfo: '配達先',
  receiveDate: '最短納品日 {date}',
  transportName: '便',
  evaluateTitle: '商品レビュー',
  evaluateAll: '全て表示',
  evaluateAllBottom: '全ての見る',
  evaluateNoList: 'レビューがありません',
  productDesc: '商品詳細',
  productNoDesc: '商品説明がありません',
  btnProductStatus: '終売',
  btnInventoryQuantity: '入荷通知',
  btnAddCart: 'カートに入れる',
  proNum: '数量',
  inventoryQuantity: '一時在庫切れ',
  mpContent: '公式アカウント{name}にメッセージを送ってください。',
  mpBtn: 'アカウント名をコピー',
  serverTitle: 'カスタマーサポート',
  mycouponTitle: '登録済',
  availableCoupon: '登録可能',
  couponType1: 'ｸｰﾎﾟﾝ(￥)',
  couponType2: 'ｸｰﾎﾟﾝ(%)',
  couponType3: 'ｸｰﾎﾟﾝ(送料)',
  // couponType1UseMoney: '{useMoneyCondition}円以上{discountInfo}円OFF',
  // couponType1NoUseMoney: '{discountInfo}円OFF',
  // couponType2UseMoney: '{useMoneyCondition}円以上{discountInfo}%OFF',
  // couponType2NoUseMoney: '{discountInfo}%OFF',
  // couponType3UseMoney: '{useMoneyCondition}円以上{discountInfo}送料無料',
  // couponType3NoUseMoney: '{discountInfo}送料無料',

  couponType1UseMoney_text1: '满',
  couponType1UseMoney_text2: '减',
  couponType1NoUseMoney: '任意金额减',
  couponType2UseMoney: '享{discountInfo}%OFF',
  couponType2NoUseMoney: '任意金额享{discountInfo}%OFF',
  couponType3UseMoney: '包邮{discountInfo}',
  couponType3NoUseMoney: '任意金额包邮{discountInfo}',
  freeTransportName: '{freetransportName}送料無料',
  couponProductType: '一部商品利用可能',
  freeTransportType: '{freeTransportAreaName}送料無料',
  freeTransportTypeYw: '{freeTransportAreaName}以外送料無料',
  receiveNum: '{num}枚まで登録可能',
  useDate: '有効期限',
  dateInterval: '〜',
  dateSameDay: '登録日から ',
  dateNextDay: '登録翌日から ',
  valiateDay: '日以内有効',
  receive: '登録',
  toUse: 'クーポン使用',
  CouponSuccess: 'クーポンを登録しました',
  CollectSuccess: '気に入りに登録しました。',
  specsConfirmSuccess: '入荷通知を登録しました',
  activitTextStart: 'キャンペン開始まであと',
  activitTextEnd: 'キャンペン終了まであと',
  RelatedList: '関連商品',
  HistoryList: '閲覧履歴',
  noProduct: '該当商品がありません',
  tips: 'システムがお届け先に基いて納品日を自動予測します。納品時間は注文レジ画面でご指定できます。本サービスは無料でご利用できます。天候、交通状況などの不可抗力でご希望の納品時間に添えない場合がございますので、予めご了承ください。',
  allcouponProductType: '全ての商品利用可能',
  copySuccess: '公式アカウントIDがコピーしました'
};